package com.essntl.features.proposal.ui.selectservice.components

import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.foundation.background
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.proposal.ui.selectservice.SelectServiceNavigation
import com.essntl.features.service.domain.model.service.ServiceModel
import com.essntl.features.tag.domain.model.TagModel
import com.essntl.uikit.components.image.AsyncUrlIcon
import com.essntl.uikit.components.image.AsyncUrlImage
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalLayoutApi::class, ExperimentalFoundationApi::class)
@Composable
fun ServiceCard(
    service: ServiceModel,
    category: CategoryModel?,
    tagList: List<TagModel>,
    onClick: () -> Unit,
    onDoubleClick: () -> Unit,
    modifier: Modifier = Modifier,
) {
    Row(
        modifier = modifier
            .fillMaxWidth()
            .height(90.dp)
            .clip(RoundedCornerShape(20.dp))
            .combinedClickable(
                onClick = onClick,
                onDoubleClick = onDoubleClick,
            )
            .background(MaterialTheme.esColorScheme.bgSecondary),
    ) {
        AsyncUrlImage(
            url = service.primaryImage?.url ?: "",
            placeholder = {
                AsyncUrlIcon(
                    url = category?.iconUrl ?: "",
                    placeholder = {
                        EsSpinner()
                    },
                    contentDescription = category?.name,
                    tint = Color(0xFF8985A2),
                    modifier = Modifier
                        .fillMaxSize(.4f)
                )
            },
            contentDescription = "primaryImage",
            contentScale = ContentScale.Crop,
            modifier = Modifier
                .weight(0.4f)
                .fillMaxHeight(),
        )

        Column(
            modifier = Modifier
                .weight(1f)
                .fillMaxHeight()
                .padding(1.spacing),
        ) {
            Text(
                text = service.title.replaceFirstChar { it.uppercaseChar() },
                color = MaterialTheme.esColorScheme.textPrimary,
                style = MaterialTheme.esTypography.p2Regular14,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )

            FlowRow(
                verticalArrangement = Arrangement.spacedBy(6.dp),
                horizontalArrangement = Arrangement.spacedBy(6.dp),
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(bottom = 2.spacing),
            ) {
                tagList.forEach { tag ->
                    key(tag.id) {
                        TagServiceItem(
                            tag = tag,
                        )
                    }
                }
            }
        }
    }
}